import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import React, { useContext, useRef, useEffect, useState, useCallback, useLayoutEffect, useMemo, useImperativeHandle } from 'react';
import { useMergedState } from '../_utils/hooks';
import isBoolean from 'lodash/isBoolean';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { toArray } from '../_utils/react-children';
import { Icon, Checkbox, Tag } from '../index';
import Option from './option';
import usePopper from '../_utils/usePopper';
import VirtualList from '../virtual-list';
import KeyCode from '../_utils/KeyCode';
var INPUT_MIN_WIDTH = 4; // 输入框最小宽度
var InternalSelect = function InternalSelect(props, ref) {
  var _context, _classNames6, _classNames12, _context5;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps,
    locale = _useContext.locale;
  var selectProps = getCompProps('Select', userDefaultProps, props);
  var selectLangMsg = locale.getCompLangMsg({
    componentName: 'Select'
  });
  var size = selectProps.size,
    value = selectProps.value,
    autoFocus = selectProps.autoFocus,
    className = selectProps.className,
    defaultOpen = selectProps.defaultOpen,
    dropdownClassName = selectProps.dropdownClassName,
    disabled = selectProps.disabled,
    borderType = selectProps.borderType,
    _selectProps$showArro = selectProps.showArrow,
    showArrow = _selectProps$showArro === void 0 ? true : _selectProps$showArro,
    allowClear = selectProps.allowClear,
    customPrefixcls = selectProps.prefixCls,
    onFocus = selectProps.onFocus,
    onBlur = selectProps.onBlur,
    onClear = selectProps.onClear,
    onVisibleChange = selectProps.onVisibleChange,
    mode = selectProps.mode,
    showSearch = selectProps.showSearch,
    onChange = selectProps.onChange,
    onSearch = selectProps.onSearch,
    defaultValue = selectProps.defaultValue,
    labelInValue = selectProps.labelInValue,
    children = selectProps.children,
    options = selectProps.options,
    placeholder = selectProps.placeholder,
    _selectProps$dropdown = selectProps.dropdownStyle,
    dropdownStyle = _selectProps$dropdown === void 0 ? {} : _selectProps$dropdown,
    style = selectProps.style,
    clearIcon = selectProps.clearIcon,
    filterOption = selectProps.filterOption,
    optionFilterProp = selectProps.optionFilterProp,
    optionLabelProp = selectProps.optionLabelProp,
    _selectProps$popperSt = selectProps.popperStyle,
    popperStyle = _selectProps$popperSt === void 0 ? {} : _selectProps$popperSt,
    tagRender = selectProps.tagRender,
    virtualListProps = selectProps.virtualListProps,
    status = selectProps.status;
  var isMultiple = mode === 'multiple'; // 是否多选
  var _useMergedState = useMergedState(undefined, {
      value: value,
      defaultValue: defaultValue
    }),
    _useMergedState2 = _slicedToArray(_useMergedState, 2),
    initValue = _useMergedState2[0],
    setInitValue = _useMergedState2[1];
  var realChildren = Array.isArray(options) ? options : toArray(children); // options配置项和默认children
  var selectRef = useRef();
  var searchRef = useRef(null); // 搜索框ref
  var selectionRef = useRef(null);
  var dropDownRef = useRef(null);
  var multipleRef = useRef({
    selectedVal: isMultiple ? [] : null,
    selectMulOpts: []
  }); // 多选ref已选中项
  var measureRef = useRef(null);
  var clearRef = useRef(null);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    mulOptions = _useState2[0],
    setMulOptions = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    singleVal = _useState4[0],
    setSingleVal = _useState4[1];
  var _useState5 = useState(typeof props.visible === 'undefined' ? !!defaultOpen : !!props.visible),
    _useState6 = _slicedToArray(_useState5, 2),
    optionShow = _useState6[0],
    setOptionShow = _useState6[1];
  // 下拉列表是否展示
  // const [searchInput, setSearchInput] = useState<string>('') // 搜索框值
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    searchValue = _useState8[0],
    setSearchValue = _useState8[1]; // 搜索框定时器
  var _useState9 = useState(INPUT_MIN_WIDTH),
    _useState10 = _slicedToArray(_useState9, 2),
    inputWidth = _useState10[0],
    setInputWidth = _useState10[1]; // 输入框宽度
  var _useState11 = useState(autoFocus),
    _useState12 = _slicedToArray(_useState11, 2),
    focusd = _useState12[0],
    setFocusd = _useState12[1];
  var isShowSearch = useMemo(function () {
    return isBoolean(showSearch) ? showSearch : isMultiple;
  }, [isMultiple, showSearch]);
  var selectPrefixCls = getPrefixCls(prefixCls, 'select', customPrefixcls);
  // 选择器样式
  var selectCls = classNames(selectPrefixCls, className, _defineProperty({}, "".concat(selectPrefixCls, "-visible"), optionShow));
  var selectionCls = classNames(_defineProperty({}, "".concat(selectPrefixCls, "-selector"), true));
  // 下拉列表框样式
  var dropDownCls = classNames(dropdownClassName, _defineProperty({}, "".concat(selectPrefixCls, "-dropdown"), true));
  // 下拉子项列表样式
  var dropContentCls = classNames(_defineProperty({}, "".concat(selectPrefixCls, "-dropdown-scroll"), (isMultiple ? (realChildren === null || realChildren === void 0 ? void 0 : realChildren.length) > 8 : (realChildren === null || realChildren === void 0 ? void 0 : realChildren.length) > 10) || selectProps.dropdownRender));
  // 多选底部样式
  var multipleFooterCls = classNames(_defineProperty({}, "".concat(selectPrefixCls, "-multiple-footer"), true));
  // 多选，单选公共样式
  var commCls = classNames((_classNames6 = {}, _defineProperty(_classNames6, "".concat(selectPrefixCls, "-bordered"), borderType === 'bordered'), _defineProperty(_classNames6, "".concat(selectPrefixCls, "-underline"), borderType === 'underline'), _defineProperty(_classNames6, "".concat(selectPrefixCls, "-borderless"), borderType === 'none'), _defineProperty(_classNames6, _concatInstanceProperty(_context = "".concat(selectPrefixCls, "-size-")).call(_context, size), size), _defineProperty(_classNames6, "".concat(selectPrefixCls, "-wrapper"), true), _defineProperty(_classNames6, "".concat(selectPrefixCls, "-show-search"), isShowSearch && focusd), _defineProperty(_classNames6, "".concat(selectPrefixCls, "-error"), status === 'error'), _classNames6));
  useEffect(function () {
    if (typeof props.visible !== 'undefined') {
      setOptionShow(props.visible);
    }
  }, [props.visible]);
  // realchildren更新时数据处理---待解决
  useEffect(function () {
    if (isMultiple) {
      multipleRef.current.selectedVal = Array.isArray(initValue) ? _toConsumableArray(initValue) : initValue || [];
      if (Array.isArray(initValue)) {
        if (realChildren === null || realChildren === void 0 ? void 0 : realChildren.length) {
          var _context2;
          var arr = [];
          _mapInstanceProperty(initValue).call(initValue, function (item) {
            var _a, _b;
            var obj = realChildren === null || realChildren === void 0 ? void 0 : _findInstanceProperty(realChildren).call(realChildren, function (child) {
              if (child && child.props) {
                return child.props.value === item;
              } else {
                return child.value === item;
              }
            });
            if (obj) {
              if (options && options.length) {
                arr.push({
                  value: obj === null || obj === void 0 ? void 0 : obj.value,
                  label: (obj === null || obj === void 0 ? void 0 : obj.label) || (obj === null || obj === void 0 ? void 0 : obj.value)
                });
              } else {
                arr.push({
                  value: (_a = obj.props) === null || _a === void 0 ? void 0 : _a.value,
                  label: (_b = obj.props) === null || _b === void 0 ? void 0 : _b.children
                });
              }
            } else {
              arr.push({
                value: item,
                label: item
              });
            }
          });
          setMulOptions(_concatInstanceProperty(_context2 = []).call(_context2, arr));
          multipleRef.current.selectMulOpts = _concatInstanceProperty(arr).call(arr);
        }
        if (!(initValue === null || initValue === void 0 ? void 0 : initValue.length)) {
          setMulOptions([]);
        }
      }
    }
  }, [isMultiple, initValue, children, options]);
  useEffect(function () {
    if (!isMultiple) {
      multipleRef.current.selectedVal = initValue; // 默认选中值
      if (initValue !== undefined) {
        var obj = realChildren === null || realChildren === void 0 ? void 0 : _findInstanceProperty(realChildren).call(realChildren, function (child) {
          var _a;
          if (child && child.props) {
            return ((_a = child.props) === null || _a === void 0 ? void 0 : _a.value) === initValue;
          } else {
            return (child === null || child === void 0 ? void 0 : child.value) === initValue;
          }
        });
        if (obj) {
          if (options && options.length) {
            setSingleVal(getOptionLabel(obj) || (obj === null || obj === void 0 ? void 0 : obj.value));
          } else {
            setSingleVal(getOptionLabel(obj));
          }
        } else {
          setSingleVal(initValue);
        }
      } else {
        setSingleVal(undefined);
      }
    }
  }, [initValue, realChildren]);
  useEffect(function () {
    if (optionShow === false) {
      handleClear();
    }
  }, [optionShow]);
  var handleFocus = useCallback(function (e) {
    e.stopPropagation();
    setFocusd(true);
    onFocus && onFocus(e);
  }, [onFocus]);
  var handleBlur = useCallback(function (e) {
    e.stopPropagation();
    setFocusd(false);
    onBlur && onBlur(e);
  }, [onBlur]);
  // 点击组件
  // const handleClick = () => {
  //   if (disabled) return
  //   if (optionShow) {
  //     const { onDropdownVisibleChange } = selectProps
  //     onDropdownVisibleChange && onDropdownVisibleChange(true)
  //   }
  // }
  useEffect(function () {
    selectionRef.current.addEventListener('mouseup', function (e) {
      var _a;
      var isCloseBtn = ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.className.indexOf('kd-tag-close-icon')) > -1;
      if (isCloseBtn) {
        e.stopPropagation();
      }
    });
  }, []);
  useLayoutEffect(function () {
    measureRef.current && setInputWidth(measureRef.current.scrollWidth);
  }, [searchValue]);
  var filledOptions = useMemo(function () {
    if (filterOption === false || !searchValue) {
      return realChildren;
    }
    var childrenList = [];
    var handleFilledOption = function handleFilledOption(option) {
      if (filterOption === true) {
        return String(option[optionFilterProp]).toLowerCase().indexOf(searchValue.toLowerCase()) !== -1;
      } else if (typeof filterOption === 'function') {
        return filterOption(searchValue, option);
      }
      return true;
    };
    _mapInstanceProperty(realChildren).call(realChildren, function (item) {
      if (item === null || item === undefined) return;
      var isValidOption = true;
      if ((item === null || item === void 0 ? void 0 : item.props) && (item.type.displayName === 'Option' || item.type.name === 'Option')) {
        isValidOption = handleFilledOption(item.props);
      } else {
        isValidOption = handleFilledOption(item);
      }
      if (isValidOption) {
        childrenList.push(item);
      }
    });
    return childrenList;
  }, [searchValue, realChildren, filterOption, optionFilterProp]);
  var getOptionLabel = useCallback(function (obj) {
    var _a;
    var text = Object.prototype.hasOwnProperty.call(selectProps, 'options') && !Object.prototype.hasOwnProperty.call(props, 'optionLabelProp') ? 'label' : optionLabelProp;
    if (obj.props) {
      if (text) {
        return obj === null || obj === void 0 ? void 0 : obj.props[text];
      }
      return (_a = obj.props) === null || _a === void 0 ? void 0 : _a.children;
    } else {
      if (text) {
        return obj[text];
      }
    }
    return obj === null || obj === void 0 ? void 0 : obj.label;
  }, [optionLabelProp, selectProps]);
  // 点击下拉列表中某项回调
  var handleOption = function handleOption(key, label, isSelected) {
    var _a, _b;
    var onSelect = selectProps.onSelect,
      onDeselect = selectProps.onDeselect,
      labelInValue = selectProps.labelInValue,
      value = selectProps.value;
    var obj = (realChildren === null || realChildren === void 0 ? void 0 : _findInstanceProperty(realChildren).call(realChildren, function (child) {
      var _a;
      if (child && child.props) {
        return ((_a = child.props) === null || _a === void 0 ? void 0 : _a.value) === key;
      } else {
        return (child === null || child === void 0 ? void 0 : child.value) === key;
      }
    })) || {};
    if (isMultiple) {
      (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    } else {
      (_b = searchRef.current) === null || _b === void 0 ? void 0 : _b.blur();
    }
    var optionsObj = obj.props ? obj.props : obj || {};
    if (value !== undefined) {
      if (isMultiple) {
        var _multipleRef$current = multipleRef.current,
          selectedVal = _multipleRef$current.selectedVal,
          selectMulOpts = _multipleRef$current.selectMulOpts;
        var valArr = _toConsumableArray(selectedVal);
        var optsArr = _toConsumableArray(selectMulOpts);
        if (_includesInstanceProperty(selectedVal).call(selectedVal, key)) {
          var idx = selectedVal.indexOf(key);
          _spliceInstanceProperty(valArr).call(valArr, idx, 1);
          _spliceInstanceProperty(optsArr).call(optsArr, idx, 1);
        } else {
          valArr.push(key);
          optsArr.push(_extends(_extends({}, optionsObj), {
            value: key,
            // label: obj.props ? obj.props?.children : obj.label || key,
            label: getOptionLabel(obj) || key
          }));
        }
        onChange && onChange(labelInValue ? optsArr : valArr, optsArr);
        if (!isSelected) {
          onDeselect && onDeselect(key); // 下拉项取消选中时调用，参数为选中项的value,多选模式下生效
        }
      } else {
        props.visible === undefined && setOptionShow(false);
        initValue !== key && onChange && onChange(labelInValue ? {
          value: key,
          label: label
        } : key, _extends(_extends({}, optionsObj), {
          value: key,
          label: label
        }));
      }
      onSelect && onSelect(key);
      return;
    }
    if (!isMultiple) {
      setSingleVal(getOptionLabel(obj) || key);
      multipleRef.current.selectedVal = key;
      setInitValue(key);
      props.visible === undefined && setOptionShow(false);
      initValue !== key && onChange && onChange(labelInValue ? {
        value: key,
        label: label
      } : key, _extends(_extends({}, optionsObj), {
        value: key,
        label: label
      }));
    } else {
      var _multipleRef$current2 = multipleRef.current,
        _selectedVal = _multipleRef$current2.selectedVal,
        _selectMulOpts = _multipleRef$current2.selectMulOpts;
      if (_includesInstanceProperty(_selectedVal).call(_selectedVal, key)) {
        var _idx = _selectedVal.indexOf(key);
        _spliceInstanceProperty(_selectedVal).call(_selectedVal, _idx, 1);
        _spliceInstanceProperty(_selectMulOpts).call(_selectMulOpts, _idx, 1);
      } else {
        _selectedVal.push(key);
        _selectMulOpts.push(_extends(_extends({}, optionsObj), {
          value: key,
          label: getOptionLabel(obj) || key
        }));
      }
      setMulOptions(_toConsumableArray(_selectMulOpts));
      onChange && onChange(labelInValue ? _selectMulOpts : _selectedVal, _selectMulOpts);
      if (!isSelected) {
        onDeselect && onDeselect(key); // 下拉项取消选中时调用，参数为选中项的value,多选模式下生效
      }
    }

    setSearchValue('');
    onSelect && onSelect(key); // 下拉项被选中时调用，参数为选中项value或key
  };
  // 多选模式下选中所有 与清除所有 (可以优化)
  var handleSelectAll = function handleSelectAll() {
    var _multipleRef$current3 = multipleRef.current,
      selectedVal = _multipleRef$current3.selectedVal,
      selectMulOpts = _multipleRef$current3.selectMulOpts;
    var newSelectedVal = _toConsumableArray(selectedVal);
    var newSelectMulOpts = _toConsumableArray(selectMulOpts);
    if ((filledOptions === null || filledOptions === void 0 ? void 0 : filledOptions.length) !== newSelectedVal.length) {
      _mapInstanceProperty(filledOptions).call(filledOptions, function (child) {
        var _ref = child.props || child,
          value = _ref.value;
        if (!_includesInstanceProperty(newSelectedVal).call(newSelectedVal, value)) {
          newSelectedVal.push(value);
          newSelectMulOpts.push({
            value: value,
            label: getOptionLabel(child)
          });
        }
      });
      if (typeof value === 'undefined') {
        multipleRef.current.selectedVal = newSelectedVal;
        multipleRef.current.selectMulOpts = newSelectMulOpts;
        setMulOptions(_toConsumableArray(newSelectMulOpts));
        setSearchValue('');
      }
    } else {
      newSelectedVal = [];
      newSelectMulOpts = [];
      if (typeof value === 'undefined') {
        multipleRef.current.selectedVal = [];
        multipleRef.current.selectMulOpts = [];
        setMulOptions([]);
      }
    }
    onChange && onChange(labelInValue ? newSelectMulOpts : newSelectedVal, newSelectMulOpts);
  };
  // 输入框变化搜索内容
  var handleSearchChange = useCallback(function (event) {
    var val = event.currentTarget.value;
    setOptionShow(true);
    setSearchValue(val);
    onSearch === null || onSearch === void 0 ? void 0 : onSearch(val);
  }, [onSearch]);
  // 清除搜索内容
  var handleClear = useCallback(function () {
    if (searchRef.current) {
      searchRef.current.value = '';
      setSearchValue('');
    }
  }, [searchRef]);
  // 清空选择器内容
  var handleReset = function handleReset(e) {
    e.stopPropagation();
    if (isMultiple) {
      multipleRef.current.selectedVal = [];
      multipleRef.current.selectMulOpts = [];
      setMulOptions([]);
    } else {
      setInitValue('');
    }
    onClear && onClear('');
    setSearchValue('');
    onChange && onChange(isMultiple ? '' : undefined);
  };
  // 多选模式下清除某一项
  var handleRemove = function handleRemove(e, tag) {
    if (disabled) return;
    var _multipleRef$current4 = multipleRef.current,
      selectedVal = _multipleRef$current4.selectedVal,
      selectMulOpts = _multipleRef$current4.selectMulOpts;
    var idx = selectedVal.indexOf(tag);
    _spliceInstanceProperty(selectedVal).call(selectedVal, idx, 1);
    _spliceInstanceProperty(selectMulOpts).call(selectMulOpts, idx, 1);
    setMulOptions(_toConsumableArray(selectMulOpts));
    onChange && onChange(labelInValue ? selectMulOpts : selectedVal, selectMulOpts);
    e.stopPropagation();
  };
  // 渲染后缀图标
  var renderSuffix = function renderSuffix() {
    var _classNames7;
    var suffixIcon = selectProps.suffixIcon;
    // 选择器下拉icon样式
    var arrowIconCls = classNames((_classNames7 = {}, _defineProperty(_classNames7, "".concat(selectPrefixCls, "-icon-arrow"), true), _defineProperty(_classNames7, "".concat(selectPrefixCls, "-icon-arrow-up"), optionShow), _defineProperty(_classNames7, "".concat(selectPrefixCls, "-icon-arrow-down"), !optionShow), _defineProperty(_classNames7, "".concat(selectPrefixCls, "-icon-arrow-focus"), optionShow), _classNames7));
    var iconShow = allowClear && !disabled && ((isMultiple ? mulOptions.length > 0 : (singleVal !== null && singleVal !== void 0 ? singleVal : '') !== '') || searchValue);
    var clearIconCls = classNames(_defineProperty({}, "".concat(selectPrefixCls, "-icon-clear"), true));
    return /*#__PURE__*/React.createElement(React.Fragment, null, iconShow ? /*#__PURE__*/React.createElement("span", {
      onClick: handleReset,
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      },
      className: clearIconCls,
      ref: clearRef
    }, clearIcon || /*#__PURE__*/React.createElement(Icon, {
      type: "close-solid"
    })) : null, showArrow ? /*#__PURE__*/React.createElement("span", {
      className: arrowIconCls
    }, suffixIcon || /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-down"
    })) : null);
  };
  var renderOption = function renderOption(child, index) {
    if ((child === null || child === void 0 ? void 0 : child.props) && (child.type.displayName === 'Option' || child.type.name === 'Option')) {
      return /*#__PURE__*/React.createElement(Option, _extends({
        isMultiple: isMultiple
      }, child.props, {
        key: index,
        index: index,
        activeIndex: activeIndex,
        onChangeSelect: handleOption,
        values: multipleRef.current.selectedVal,
        onChangeActiveIndex: function onChangeActiveIndex(i) {
          setActiveIndex(i);
        }
      }));
    } else {
      return /*#__PURE__*/React.createElement(Option, _extends({
        isMultiple: isMultiple,
        value: child === null || child === void 0 ? void 0 : child.value,
        key: index,
        index: index,
        activeIndex: activeIndex,
        onChangeSelect: handleOption,
        values: multipleRef.current.selectedVal,
        onChangeActiveIndex: function onChangeActiveIndex(i) {
          setActiveIndex(i);
        }
      }, child), (child === null || child === void 0 ? void 0 : child.label) || (child === null || child === void 0 ? void 0 : child.value));
    }
  };
  var dropRender = function dropRender(childrenToRender, heightStyle) {
    return /*#__PURE__*/React.createElement("div", {
      className: dropContentCls,
      style: heightStyle
    }, childrenToRender);
  };
  // 下拉列表为空时显示的内容
  var renderNotContent = function renderNotContent() {
    // 下拉列表为空
    var emptyListCls = classNames(_defineProperty({}, "".concat(selectPrefixCls, "-dropdown-empty"), true));
    var notFoundContent = selectProps.notFoundContent;
    var emptyContent = notFoundContent || '暂无数据';
    return (filledOptions === null || filledOptions === void 0 ? void 0 : filledOptions.length) === 0 && /*#__PURE__*/React.createElement("div", {
      className: emptyListCls
    }, emptyContent);
  };
  useEffect(function () {
    var _a;
    if (isShowSearch && autoFocus && !disabled) {
      (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, [isShowSearch, autoFocus, disabled]);
  var optionsListRef = React.useRef(null);
  // 渲染下拉列表框
  var renderContent = function renderContent() {
    var dropdownRender = selectProps.dropdownRender,
      listHeight = selectProps.listHeight;
    var selectedVal = multipleRef.current.selectedVal;
    var childrenToRender = filledOptions;
    var eleOptionList = filledOptions;
    if (Array.isArray(childrenToRender) && childrenToRender.length > 0) {
      childrenToRender = _mapInstanceProperty(childrenToRender).call(childrenToRender, function (item, index) {
        if (item === null || item === undefined) return;
        var temp = renderOption(item, index);
        return temp;
      });
      eleOptionList = /*#__PURE__*/React.createElement(VirtualList, _extends({
        role: "listbox",
        data: childrenToRender,
        itemKey: function itemKey(child) {
          var _a;
          return (_a = child.props) === null || _a === void 0 ? void 0 : _a.value;
        },
        onMouseDown: function onMouseDown(e) {
          return e === null || e === void 0 ? void 0 : e.preventDefault();
        },
        isStaticItemHeight: true,
        height: listHeight || 300,
        measureLongestItem: false,
        ref: optionsListRef
      }, virtualListProps), function (child) {
        return child;
      });
    }
    var heightStyle = {
      maxHeight: listHeight || '300px'
    };
    // 下拉框style属性
    var checkboxStyle = {
      height: '30px',
      background: 'none'
    };
    var indeterminate = mulOptions.length > 0 && mulOptions.length < filledOptions.length;
    var checked = mulOptions.length > 0 && mulOptions.length === filledOptions.length;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: dropDownCls,
      style: dropdownStyle,
      ref: dropDownRef
    }, !dropdownRender && childrenToRender.length > 0 ? dropRender(eleOptionList, heightStyle) : null, renderNotContent(), /*#__PURE__*/React.createElement("div", null, dropdownRender ? dropdownRender(dropRender(eleOptionList, heightStyle)) : null), isMultiple && realChildren.length > 0 ? /*#__PURE__*/React.createElement("div", {
      className: multipleFooterCls
    }, /*#__PURE__*/React.createElement(Checkbox, {
      style: checkboxStyle,
      checked: checked,
      indeterminate: indeterminate,
      onChange: handleSelectAll
    }, selectLangMsg === null || selectLangMsg === void 0 ? void 0 : selectLangMsg.selectAll), /*#__PURE__*/React.createElement("span", {
      className: "".concat(selectPrefixCls, "-multiple-footer-hadSelected")
    }, locale.getLangMsg('Select', 'seleted', {
      size: /*#__PURE__*/React.createElement("span", {
        className: "".concat(selectPrefixCls, "-multiple-footer-hadSelected-number")
      }, selectedVal.length)
    }))) : null));
  };
  // 处理多选tag
  var handleMaxTagHolder = useCallback(function () {
    var maxTagPlaceholder = selectProps.maxTagPlaceholder;
    if (typeof maxTagPlaceholder === 'function') {
      return /*#__PURE__*/React.createElement(Tag, {
        type: "edit",
        size: size,
        disabled: disabled
      }, maxTagPlaceholder(mulOptions));
    } else {
      return /*#__PURE__*/React.createElement(Tag, {
        type: "edit",
        size: size,
        disabled: disabled
      }, maxTagPlaceholder);
    }
  }, [mulOptions]);
  var renderSingle = function renderSingle() {
    var _a, _b, _c;
    var obj = (realChildren === null || realChildren === void 0 ? void 0 : _findInstanceProperty(realChildren).call(realChildren, function (child) {
      var _a;
      if (child && child.props) {
        return ((_a = child.props) === null || _a === void 0 ? void 0 : _a.value) === initValue;
      } else {
        return (child === null || child === void 0 ? void 0 : child.value) === initValue;
      }
    })) || {};
    var title = '';
    if (obj.props) {
      title = ((_a = obj === null || obj === void 0 ? void 0 : obj.props) === null || _a === void 0 ? void 0 : _a.title) || ((_b = obj === null || obj === void 0 ? void 0 : obj.props) === null || _b === void 0 ? void 0 : _b.label) || ((_c = obj === null || obj === void 0 ? void 0 : obj.props) === null || _c === void 0 ? void 0 : _c.children);
    } else {
      title = (obj === null || obj === void 0 ? void 0 : obj.title) || (obj === null || obj === void 0 ? void 0 : obj.label) || (obj === null || obj === void 0 ? void 0 : obj.children);
    }
    var hiddenStyle = isShowSearch && !!searchValue || singleVal ? {
      visibility: 'hidden'
    } : undefined;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: singleCls,
      ref: selectionRef,
      title: title
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(selectPrefixCls, "-selection-search")
    }, /*#__PURE__*/React.createElement("input", {
      ref: searchRef,
      value: searchValue,
      className: "".concat(selectPrefixCls, "-selection-search-input"),
      onChange: handleSearchChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      readOnly: !isShowSearch || !!disabled
    })), singleVal && !searchValue ? /*#__PURE__*/React.createElement("span", {
      className: "".concat(selectPrefixCls, "-selection-item")
    }, singleVal) : null, /*#__PURE__*/React.createElement("span", {
      className: "".concat(selectPrefixCls, "-placeholder"),
      style: hiddenStyle
    }, placeholder), /*#__PURE__*/React.createElement("span", {
      className: "".concat(selectPrefixCls, "-suffix")
    }, renderSuffix())));
  };
  // 渲染多选选择器 (待优化：多选框下拉按钮样式调整，限制tag数代码优化)
  var renderMultiple = function renderMultiple() {
    var _context3, _classNames10, _context4, _classNames11;
    var maxTagCount = selectProps.maxTagCount,
      maxTagPlaceholder = selectProps.maxTagPlaceholder;
    var multipleCls = classNames(commCls, (_classNames10 = {}, _defineProperty(_classNames10, "".concat(selectPrefixCls, "-multiple-disabled"), disabled), _defineProperty(_classNames10, _concatInstanceProperty(_context3 = "".concat(selectPrefixCls, "-")).call(_context3, mode), mode), _defineProperty(_classNames10, "".concat(selectPrefixCls, "-focused"), focusd || optionShow), _classNames10));
    var itemCls = classNames((_classNames11 = {}, _defineProperty(_classNames11, "".concat(selectPrefixCls, "-selection-item"), true), _defineProperty(_classNames11, _concatInstanceProperty(_context4 = "".concat(selectPrefixCls, "-selection-item-")).call(_context4, size), size), _classNames11));
    var TagStyle = {
      margin: '2px 8px 2px 0',
      maxWidth: '100%'
    };
    return /*#__PURE__*/React.createElement("div", {
      className: multipleCls,
      ref: selectionRef
    }, Array.isArray(mulOptions) ? /*#__PURE__*/React.createElement(React.Fragment, null, _mapInstanceProperty(mulOptions).call(mulOptions, function (item, index) {
      var label = item.label,
        value = item.value;
      return !maxTagCount || index <= maxTagCount - 1 ? /*#__PURE__*/React.createElement("span", {
        key: value,
        className: classNames("".concat(selectPrefixCls, "-selection-tag")),
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        }
      }, typeof tagRender === 'function' ? tagRender === null || tagRender === void 0 ? void 0 : tagRender({
        onClose: handleRemove,
        value: value,
        label: label,
        disabled: disabled,
        size: size
      }) : /*#__PURE__*/React.createElement(Tag, {
        type: "edit",
        style: TagStyle,
        size: size,
        closable: true,
        disabled: disabled,
        onClose: function onClose(e) {
          return handleRemove(e, value);
        },
        "data-tag": value
      }, label)) : null;
    }), maxTagCount && mulOptions.length > maxTagCount ? maxTagPlaceholder ? handleMaxTagHolder() : /*#__PURE__*/React.createElement("span", {
      className: itemCls
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(selectPrefixCls, "-selection-item-content")
    }, "\u5171", mulOptions.length, "\u9879")) : null) : null, /*#__PURE__*/React.createElement("span", {
      className: "".concat(selectPrefixCls, "-selection-search"),
      style: {
        width: inputWidth
      }
    }, /*#__PURE__*/React.createElement("input", {
      ref: searchRef,
      value: searchValue,
      className: "".concat(selectPrefixCls, "-selection-search-input"),
      onChange: handleSearchChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      readOnly: !isShowSearch || !!disabled
    }), /*#__PURE__*/React.createElement("span", {
      ref: measureRef,
      className: "".concat(selectPrefixCls, "-selection-search-mirror")
    }, searchValue, "\xA0")), /*#__PURE__*/React.createElement("span", {
      className: "".concat(selectPrefixCls, "-placeholder")
    }, !mulOptions.length && !searchValue ? placeholder : null), /*#__PURE__*/React.createElement("span", {
      className: "".concat(selectPrefixCls, "-suffix")
    }, renderSuffix()));
  };
  var singleCls = classNames(commCls, (_classNames12 = {}, _defineProperty(_classNames12, "".concat(selectPrefixCls, "-single"), true), _defineProperty(_classNames12, "".concat(selectPrefixCls, "-single-disabled"), disabled), _defineProperty(_classNames12, "".concat(selectPrefixCls, "-single-focused"), focusd && !disabled || optionShow), _classNames12));
  // keyboard
  var getActiveIndex = function getActiveIndex(index) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var len = filledOptions.length;
    for (var i = 0; i < len; i += 1) {
      var current = (index + i * offset + len) % len;
      var _props = filledOptions[current].props;
      if (!(_props === null || _props === void 0 ? void 0 : _props.disabled)) {
        return current;
      }
    }
    return -1;
  };
  // reset activeIndex
  useEffect(function () {
    if (searchValue) {
      setActiveIndex(getActiveIndex(0));
    }
  }, [searchValue]);
  useEffect(function () {
    if (optionShow && !disabled) {
      var onDropdownVisibleChange = selectProps.onDropdownVisibleChange;
      onDropdownVisibleChange && onDropdownVisibleChange(true);
    }
  }, [optionShow]);
  useEffect(function () {
    var _a;
    var fn = function fn(e) {
      e.stopPropagation();
    };
    (_a = clearRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('mouseup', fn);
    return function () {
      var _a;
      (_a = clearRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('mouseup', fn);
    };
  }, [singleVal, mulOptions]);
  useImperativeHandle(ref, function () {
    return {
      select: selectRef.current,
      focus: function focus() {
        var _a;
        setFocusd(true);
        (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      },
      blur: function blur() {
        var _a;
        setFocusd(false);
        (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      }
    };
  });
  var _useState13 = useState(isShowSearch ? getActiveIndex(0) : -1),
    _useState14 = _slicedToArray(_useState13, 2),
    activeIndex = _useState14[0],
    setActiveIndex = _useState14[1];
  var onInternalKeyDown = function onInternalKeyDown(e) {
    var _a, _b;
    var which = e.which;
    // open
    if (which === KeyCode.ENTER || which === KeyCode.UP || which === KeyCode.DOWN) {
      e.preventDefault();
      handleVisibleChange(true);
    }
    // backspace
    var _multipleRef$current5 = multipleRef.current,
      selectedVal = _multipleRef$current5.selectedVal,
      selectMulOpts = _multipleRef$current5.selectMulOpts;
    // isMultiple
    if (which === KeyCode.BACKSPACE && !searchValue && isMultiple && selectedVal.length && selectMulOpts.length) {
      _spliceInstanceProperty(selectedVal).call(selectedVal, -1, 1);
      _spliceInstanceProperty(selectMulOpts).call(selectMulOpts, -1, 1);
      setMulOptions(_toConsumableArray(selectMulOpts));
      onChange && onChange(labelInValue ? selectMulOpts : selectedVal, selectMulOpts);
    }
    // optionsList: up、down、enter
    if (optionShow) {
      var offset = 0;
      if (which === KeyCode.UP) {
        offset = -1;
      } else if (which === KeyCode.DOWN) {
        offset = 1;
      } else if (which === KeyCode.ENTER) {
        var item = filledOptions[activeIndex];
        if (!item) return;
        var key = ((_a = item.props) === null || _a === void 0 ? void 0 : _a.value) || item.value;
        var label = ((_b = item.props) === null || _b === void 0 ? void 0 : _b.children) || item.label;
        handleOption(key, label, true);
        // search
        if (searchValue) {
          setActiveIndex(_findIndexInstanceProperty(realChildren).call(realChildren, function (child) {
            var _a;
            if (child && child.props) {
              return ((_a = child.props) === null || _a === void 0 ? void 0 : _a.value) === key;
            } else {
              return (child === null || child === void 0 ? void 0 : child.value) === key;
            }
          }));
        }
        if (!isMultiple) {
          handleVisibleChange(false);
        }
      } else if (which === KeyCode.ESC) {
        handleVisibleChange(false);
      }
      if (offset !== 0) {
        var nextActiveIndex = getActiveIndex(activeIndex + offset, offset);
        if (optionsListRef.current) {
          optionsListRef.current.scrollTo({
            index: nextActiveIndex
          });
        }
        setActiveIndex(nextActiveIndex);
        e.preventDefault();
      }
    }
  };
  var renderSelect = function renderSelect() {
    return /*#__PURE__*/React.createElement("div", {
      className: selectCls,
      ref: selectRef,
      style: style
    }, /*#__PURE__*/React.createElement("span", {
      className: selectionCls,
      tabIndex: disabled ? -1 : 0,
      onFocus: function onFocus() {
        var _a;
        return (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      },
      onBlur: function onBlur() {
        var _a;
        return (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      },
      onKeyDown: onInternalKeyDown
    }, !isMultiple ? renderSingle() : renderMultiple()));
  };
  var catchStyle = function catchStyle() {
    var _a;
    if (selectRef === null || selectRef === void 0 ? void 0 : selectRef.current) {
      var _ref2 = (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(),
        width = _ref2.width;
      return _extends(_extends(_extends({
        minWidth: width,
        maxWidth: 600
      }, dropdownStyle), {
        width: (dropdownStyle === null || dropdownStyle === void 0 ? void 0 : dropdownStyle.width) || 'auto',
        zIndex: 1050
      }), popperStyle);
    }
  };
  var handleVisibleChange = function handleVisibleChange(visible) {
    if (!visible) {
      setActiveIndex(isShowSearch ? getActiveIndex(0) : -1);
    }
    if (visible !== optionShow) {
      props.visible === undefined && setOptionShow(visible);
      onVisibleChange && onVisibleChange(visible);
    }
  };
  var popperProps = _extends(_extends({}, selectProps), {
    prefixCls: _concatInstanceProperty(_context5 = "".concat(selectPrefixCls, "-dropdown-panel")).call(_context5, isMultiple ? " ".concat(selectPrefixCls, "-multiple-dropdown-panel") : ''),
    placement: 'bottomLeft',
    popperStyle: catchStyle(),
    defaultVisible: optionShow,
    visible: optionShow,
    onVisibleChange: handleVisibleChange,
    clickToClose: !(isShowSearch && searchValue)
  });
  return usePopper(renderSelect(), renderContent(), popperProps);
};
var Select = /*#__PURE__*/React.forwardRef(InternalSelect);
Select.displayName = 'Select';
export default Select;